export default __webpack_public_path__ + "static/media/E14.f326cfcc.jpeg";